import { PetDetails } from '@weave/schema-gen-ts/dist/schemas/pets-api/v1/pets_api.pb';
import { useTranslation } from '@frontend/i18n';
import { Chip, useTooltip } from '@frontend/design-system';
import { PetIcon } from './pet-icon';
import { PetList } from './pet-list';

export const PetSummary = ({ pets }: { pets: PetDetails[] }) => {
  const { Tooltip, triggerProps, tooltipProps } = useTooltip();
  const { t } = useTranslation();
  return (
    <>
      <Tooltip {...tooltipProps} css={{ maxWidth: '70vw' }} theme='light'>
        <PetList pets={pets} />
      </Tooltip>
      <Chip.Pet
        css={{ width: 'min-content' }}
        name={t('{{count}} pets', { count: pets.length })}
        leftElement={<PetIcon size={16} />}
        {...triggerProps}
      />
    </>
  );
};
